import React, { useEffect, useState } from "react";
import moment from "moment";
import { AccountLayout } from "./accountUi";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import obj from "../../Utils/helpers";
import { startCase } from "lodash";
import { PageShell, FilterCard, ActionButton, TableCard, selectStyle, dateStyle, thStyle, tdStyle, EntriesHeader, Pager } from "./accountUi";

/* Bets History — reference kingexch111.com/bet-history. */

const BetsHistoryNew = () => {
  const [sport, setSport] = useState("Cricket");
  const [statusType, setStatusType] = useState("Settle");
  const [from, setFrom] = useState(moment().subtract(1, "day").format("YYYY-MM-DD"));
  const [to, setTo] = useState(moment().format("YYYY-MM-DD"));
  const [limit, setLimit] = useState(10);
  const [rows, setRows] = useState([]);

  const sportToEventType = { Cricket: 4, Tennis: 2, Soccer: 1 };
  const statusMap = { Settle: "completed", Unsettle: "active", Void: "voided", Cancel: "cancelled" };

  const fetchData = async () => {
    const collected = [];
    for (const betType of ["betfair", "sportBook", "fancy"]) {
      try {
        const { status, data } = await apiGet(apiPath.getHistory, {
          betType,
          status: statusMap[statusType] || "completed",
          fromPeriod: from,
          toPeriod: to,
          eventType: sportToEventType[sport],
          page: 1,
          limit,
        });
        if (status === 200 && data?.success) {
          const list = Array.isArray(data?.results) ? data.results : data?.results?.data || [];
          list.forEach((b) => collected.push(b));
        }
      } catch (e) {
        /* ignore */
      }
    }
    setRows(collected);
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AccountLayout>
      <PageShell>
        <FilterCard>
          <div style={{ display: "flex", gap: "10px" }}>
            <select value="Data Source" disabled style={{ ...selectStyle, flex: 1 }}>
              <option>Data Source</option>
            </select>
            <select value={sport} onChange={(e) => setSport(e.target.value)} style={{ ...selectStyle, flex: 1 }}>
              <option>Cricket</option>
              <option>Tennis</option>
              <option>Soccer</option>
            </select>
          </div>
          <select value={statusType} onChange={(e) => setStatusType(e.target.value)} style={selectStyle}>
            <option>Settle</option>
            <option>Unsettle</option>
            <option>Void</option>
            <option>Cancel</option>
          </select>
          <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} style={dateStyle} />
          <input type="date" value={to} onChange={(e) => setTo(e.target.value)} style={dateStyle} />
          <ActionButton onClick={fetchData}>Get History</ActionButton>
        </FilterCard>

        <TableCard title="Bet History">
          <EntriesHeader limit={limit} setLimit={setLimit} />
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "620px" }}>
              <thead>
                <tr>
                  <th style={thStyle}>Sport Name</th>
                  <th style={thStyle}>Event Name</th>
                  <th style={thStyle}>Market name</th>
                  <th style={thStyle}>Selection</th>
                  <th style={thStyle}>Type</th>
                  <th style={thStyle}>Odds</th>
                  <th style={thStyle}>Stake</th>
                  <th style={thStyle}>Date</th>
                </tr>
              </thead>
              <tbody>
                {rows.length > 0 ? (
                  rows.map((r, i) => (
                    <tr key={i}>
                      <td style={tdStyle}>{sport}</td>
                      <td style={tdStyle}>{r?.matchName || r?.eventName}</td>
                      <td style={tdStyle}>{r?.fancyName || r?.market || "Match Odds"}</td>
                      <td style={tdStyle}>{r?.teamName || r?.runnerName || r?.fancyName}</td>
                      <td style={tdStyle}>{startCase(r?.betType || r?.type || "")}</td>
                      <td style={tdStyle}>{r?.betRun ? `${r?.betRun}/${r?.bhav}` : r?.bhav}</td>
                      <td style={tdStyle}>{r?.amount}</td>
                      <td style={tdStyle}>{obj.dateFormat(r?.timeInserted)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td style={tdStyle} colSpan={8}>
                      No data available in table
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <Pager showingText={`Showing ${rows.length === 0 ? 0 : 1} to ${rows.length} of ${rows.length} entries`} />
        </TableCard>
      </PageShell>
    </AccountLayout>
  );
};

export default BetsHistoryNew;
